import { useCSVDownloader } from 'react-papaparse';
import { IconCSV } from '../../../../shared/Icons/IconCSV';

interface CSVDownloadProps {
  dataSource: any;
  filename: string;
  onCancel: () => void;
}

export function CSVDownload({ dataSource, filename, onCancel }: CSVDownloadProps) {
  const { CSVDownloader, Type } = useCSVDownloader();

  return (
    <CSVDownloader
      type={Type.Button}
      filename={filename}
      className="px-2 rounded-sm"
      bom={true}
      config={
        {
          delimiter: ';',
        }
      }
      data={dataSource}
    >
      {/* Download */}
      <i className="text-primary hover:text-primary-hover" onClick={onCancel}>
        <IconCSV />
      </i>
    </CSVDownloader>
  );
}
